import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface LogoutResponse extends APIResponse
{
   
}

export class LogoutResponseDtoImpl extends APIResponseDtoImpl implements LogoutResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/logout/logoutresponse.tsx